$(document).ready(function(){

  /* Content Slider */

  $('.content-slider ul').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 5000,
    customPaging : function(slider, i) {
      var title = $(slider.$slides[i]).data('title');
      return '<a><span class="number">' + (i + 1) + '</span>' + '<span class="title">' + title + '</span></a>';
    },
  });

  /* Partners Slider */

  $('.partners-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  /* Center */

  $('.center').slick({
    centerMode: true,
    centerPadding: '2px',
    slidesToShow: 5,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });

  /* Post Slider */

  $('.post-slider__tiles').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    fade: false,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

});